import styles from './Loading.module.scss'
import CheffIcon from '../../assets/vectors/tp-chef.svg'

const LoadingComponent = () => {
    return (
        <div className={styles.content}>
           <img src={CheffIcon} alt="Brand Teprovocapp" style={{ height: '100px', width: '100px' }}/>
        </div>
    )
}

export default LoadingComponent
